<template>
  <el-aside class="aside borde">
    <el-button plain type="warning" @click="micuenta" v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/avatar.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Mi Cuenta") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="home" v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/dashboard.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Dashboard Personal") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="goBloqueos" v-if="isAdmin() &&
      this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/security.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Bloqueos") }}</span>
    </el-button>
    <br v-if="isAdmin() &&
      this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="changeRole" v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/cambio.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Cambio de Rol") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="dashboard">
      <img src="@/assets/aside/tablero.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Dashboard / Tablero") }}</span>
    </el-button>
    <br>
    <el-button plain type="warning" @click="soporte" v-if="isAdmin() &&
      this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/soporte.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Soporte") }}</span>
    </el-button>
    <br v-if="isAdmin() &&
      this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="inventory" v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/inventarios.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Listado de Inventarios") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="riesgos" v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
      <img src="@/assets/aside/estandarizado.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Riesgos estandarizados") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles' &&
      $store.getters.isLoggedIn
      ">
    <el-button plain type="warning" @click="areas"
      v-if="(isAdmin() || ((($store.getters.role && $store.getters.role.role && ['super'].includes($store.getters.role.role)) || (['5f7f3bbe051e88001351a85b', '5c181278c7282000124ef44b', '5bca1eeee28f9400122650ee', '62e9996956913e0012e41481'].includes(user._id))) && !['GeneralAreasRoles'].includes($store.getters.role.area_id))) && this.$route.path !== '/es/seleccionar-roles'">
      <img src="@/assets/aside/areas.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Áreas") }}</span>
    </el-button>
    <br
      v-if="(isAdmin() || ((($store.getters.role && $store.getters.role.role && ['super'].includes($store.getters.role.role)) || (['5f7f3bbe051e88001351a85b', '5c181278c7282000124ef44b', '5bca1eeee28f9400122650ee', '62e9996956913e0012e41481'].includes(user._id))) && !['GeneralAreasRoles'].includes($store.getters.role.area_id))) && this.$route.path !== '/es/seleccionar-roles'">
    <el-button plain type="warning" @click="empresas" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <img src="@/assets/aside/empresas.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Empresas") }}</span>
    </el-button>
    <br v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
    <el-button plain type="warning" @click="usuarios" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/aside/usuarios.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Usuarios") }}</span>
    </el-button>
    <br v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
    <el-button plain type="warning" @click="contratos" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/aside/contratos.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Contratos") }}</span>
    </el-button>
    <br v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
    <el-button plain type="warning" @click="flujos" v-if="this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/aside/flujos.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Flujos") }}</span>
    </el-button>
    <br v-if="this.$route.path !== '/es/seleccionar-roles'">
    <el-button plain type="warning" @click="importacion"
      v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles' && !$store.getters.user.readonly">
      <br />
      <img src="@/assets/aside/importar.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Importación") }}</span>
    </el-button>
    <br v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles' && !$store.getters.user.readonly">
    <el-button plain type="warning" @click="reportes"
      v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles' && $store.getters.role.faena_id !== '64a65c1002ea56559c3c8b80'">
      <br />
      <img src="@/assets/aside/reportes.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Reportes") }}</span>
    </el-button>
    <br v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles' && !$store.getters.user.readonly">
    <el-button plain type="warning" @click="asignRol"
      v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/aside/reportes.gif" width="30px" />
      <br />
      <span style="font-size: 10px">{{ $t("Asignación de usuarios") }}</span>
    </el-button>
    <br
      v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles' && $store.getters.role.faena_id !== '64a65c1002ea56559c3c8b80'" />
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      window,
      select: null,
    };
  },
  computed: {
    role() {
      return this.$store.getters.role || {};
    },
    user() {
      return this.$store.getters.user || {};
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
  },
  watch: {
    select(newVal, oldVal) {
      if (newVal.tagName !== "DIV") {
        newVal.parentElement.classList.add("selected");
      } else {
        newVal.classList.add("selected");
      }
      if (oldVal) {
        if (oldVal.tagName === "DIV") {
          oldVal.classList.remove("selected");
        } else {
          oldVal.parentElement.classList.remove("selected");
        }
      }
    },
  },
  methods: {
    asignRol(event) {
      this.select = event.target;
      this.$router.push({ name: "asignarRol" });
      this.$store.dispatch("setTareaVista", "");
    },
    isAdmin() {
      if (!this.$store.getters.role) return false;
      return this.$store.getters.role.admin || false;
    },
    micuenta(event) {
      this.select = event.target;
      this.$router.push({ name: "MiCuenta" });
      this.$store.dispatch("setTareaVista", "");
    },
    home(event) {
      this.select = event.target;
      this.$router.push({ name: "dashboardPersonal" });
      this.$store.dispatch("setTareaVista", "");
    },
    dashboard() {
      this.$router.push({
        path: "/es/Dashboard",
        query: { faena: this.$store.getters.role.faena_id },
      });
      this.$store.dispatch("setTareaVista", "");
    },
    areas(event) {
      this.select = event.target;
      this.$router.push("/admin/areas");
      this.$store.dispatch("setTareaVista", "");
    },
    empresas(event) {
      this.select = event.target;
      this.$router.push("/admin/empresas");
      this.$store.dispatch("setTareaVista", "");
    },
    goBloqueos(event) {
      this.select = event.target;
      this.$router.push("/admin/bloqueos");
      this.$store.dispatch("setTareaVista", "");
    },
    soporte(event) {
      this.select = event.target;
      this.$router.push("/admin/soporte");
      this.$store.dispatch("setTareaVista", "");
    },
    usuarios(event) {
      this.select = event.target;
      this.$router.push("/admin/usuarios");
      this.$store.dispatch("setTareaVista", "");
    },
    contratos(event) {
      this.select = event.target;
      this.$router.push("/admin/contratos");
      this.$store.dispatch("setTareaVista", "");
    },
    riesgos(event) {
      this.select = event.target;
      this.$router.push("/admin/riesgos-estandarizados");
      this.$store.dispatch("setTareaVista", "");
    },
    flujos(event) {
      this.select = event.target;
      this.$router.push("/admin/workflows");
      this.$store.dispatch("setTareaVista", "");
    },
    importacion(event) {
      this.select = event.target;
      this.$router.push("/admin/import");
      this.$store.dispatch("setTareaVista", "");
    },
    reportes(event) {
      this.select = event.target;
      this.$router.push("/admin/reports");
      this.$store.dispatch("setTareaVista", "");
    },
    inventory(event) {
      this.select = event.target;
      this.$router.push({ name: "inventorySelectPage" });
      this.$store.dispatch("setTareaVista", "");
    },
    changeRole(event) {
      this.select = event.target;
      this.$router.push({ name: "SelectRoles" });
      this.$store.dispatch("setTareaVista", "");
    },
    tutorial(event) {
      this.select = event.target;
      this.$store.dispatch("setTareaVista", "");
    },
  },
};
</script>


<style scoped>
.el-button--warning.is-plain {
  color: black !important;
  border-radius: 0px !important;
}

.aside {
  text-align: center;
  min-height: 100vh;
  background-color: white;
  width: 87px !important;
}

.aside button {
  padding: 5px !important;
  width: 100%;
}

.el-button--info.is-plain {
  color: black !important;
}

.aside img {
  margin-bottom: 3px;
}

.selected {
  background-color: #353535;
}</style>
